import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { Box, IconButton, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { IoMdAdd } from 'react-icons/io';
import {IoMdSave } from 'react-icons/io';
import productService from '../../../../services/productService';
import { validateExcelAdd } from '../../../../utils/validation';
import { useSelector } from 'react-redux';
import useAlert from '../../../../hooks/useAlert';

const ExcelUploader = ({ onFilesChange }) => {
  const [files, setFiles] = useState([]);
  const [type, setType] = useState('');
  const [formErrors, setFormErrors] = useState({});
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const userId = useSelector((state) => state?.auth?.user?.id);
  const { showErrorAlertExcelAdd, showSuccessAlertexcelAdd } = useAlert();
  const onDrop = (acceptedFiles) => {
    const readFiles = (file) =>
      new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = () => {
          resolve({
            file,
            name: file.name,
            base64: reader.result.split(',')[1],
          });
        };
        reader.readAsDataURL(file);
      });

    Promise.all(acceptedFiles.map(readFiles)).then((newFiles) => {
      if (files.length + newFiles.length <= 1) {
        const updatedFiles = [...files, ...newFiles];
        setFiles(updatedFiles);
        onFilesChange(updatedFiles);
      } else {
        alert('En fazla 1 dosya yükleyebilirsiniz.');
      }
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: '.xlsx, .xls',
    multiple: true,
  });

  const removeFile = (index) => {
    const updatedFiles = [...files];
    updatedFiles.splice(index, 1);
    setFiles(updatedFiles);
    onFilesChange(updatedFiles);
  };

  const handleChange = (event) => {
    setType(event.target.value);
  };

  const addExcel = async() => {
    const data={};
    data.userId=userId;
    data.base64=files[0].base64;
    data.type=type;
    const errors = validateExcelAdd(data);
    setFormErrors(errors);
    if (Object.keys(errors).length === 0) {
    try {
        await productService.addExcel(data, token);
    
        showSuccessAlertexcelAdd();
      
    }catch{
    
      showErrorAlertExcelAdd();
   
    }
  }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        backgroundColor: '#F7F9FC',
        padding: 4,
        borderRadius: '16px',
        border: '1px solid #e0e0e0',
        width: '90%',
        maxWidth: '600px',
        mx: 'auto',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          fontWeight: 'bold',
          color: '#343089',
          textAlign: 'center',
        }}
      >
        Excel Yükleme Alanı
      </Typography>

      <Button
        {...getRootProps()}
        variant="outlined"
        startIcon={<IoMdAdd />}
        sx={{
          backgroundColor: '#fff',
          color: '#343089',
          border: '1px solid #343089',
          textTransform: 'none',
          padding: '10px 20px',
          borderRadius: '12px',
          '&:hover': {
            backgroundColor: '#f1f1f1',
            border: '1px solid #343089',
          },
        }}
      >
        <input {...getInputProps()} style={{ display: 'none' }} />
        Dosya Ekle
      </Button>

      <Box
        sx={{
          display: 'flex',
          gap: 2,
          flexWrap: 'wrap',
          backgroundColor: '#fff',
          padding: 2,
          border: '1px solid #ddd',
          borderRadius: '8px',
        }}
      >
        {files.map((file, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              padding: 1,
              border: '1px solid #ddd',
              borderRadius: '8px',
              backgroundColor: '#fafafa',
              width: '100%',
              maxWidth: '250px',
            }}
          >
            <Typography
              variant="body2"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '0.875rem',
                color: '#555',
              }}
            >
              {file.name}
            </Typography>
            <IconButton
              onClick={() => removeFile(index)}
              sx={{
                color: '#FF0000',
                '&:hover': { backgroundColor: 'rgba(255, 0, 0, 0.1)' },
              }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        ))}
      </Box>

      <FormControl fullWidth>
        <InputLabel id="excel-type-label">Excel Türü</InputLabel>
        <Select
          labelId="excel-type-label"
          id="excel-type"
          value={type}
          onChange={handleChange}
          error={!!formErrors.type}
        >
          <MenuItem value={1}>ProductProcessing</MenuItem>
          <MenuItem value={2}>StockProcessing</MenuItem>
        </Select>
        {formErrors.type && (
          <Typography variant="body2" color="error">
            {formErrors.type}
          </Typography>
        )}
      </FormControl>

      <Button
        onClick={addExcel}
        variant="contained"
        startIcon={<IoMdSave />}
        sx={{
          borderRadius: 18,
          backgroundColor: '#1F1B45',
          color: '#FFFFFF',
          textTransform: 'none',
          fontWeight: 500,
          fontSize: '0.875rem',
          padding: '10px 20px',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          '&:hover': {
            backgroundColor: '#2C285A',
          },
        }}
      >
        Kaydet
      </Button>

    </Box>
  );
};

export default ExcelUploader;
